<template>
  <!-- eslint-disable max-len -->
  <BaseFetchData :action="fetchData">
    <template #default="fetchDataProps">
      <div v-if="fetchDataProps.status.resolved" class="space-y-2">
        <ul
          v-if="draftEmailMessages.length"
          class="bg-white shadow rounded ring-1 ring-black ring-opacity-5 divide-y overflow-hidden"
        >
          <li v-for="draftEmailMessage in draftEmailMessages" :key="draftEmailMessage.id">
            <DraftEmailMessageListItem
              :email-message="draftEmailMessage"
              @edit="handleEditEmailMessage"
              @delete="handleDeleteEmailMessage"
            />
          </li>
        </ul>
        <ul
          class="bg-white shadow rounded ring-1 ring-black ring-opacity-5 divide-y overflow-hidden"
        >
          <template v-if="emailMessages.length">
            <li v-for="emailMessage in emailMessages" :key="emailMessage.id">
              <EmailMessageListItem :email-message="emailMessage" @view="handleViewEmailMessage" />
            </li>
          </template>
          <li v-else>
            <div class="text-center p-4 sm:p-6">
              <h3 class="text-sm font-medium text-gray-900">No email messages</h3>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { contactEmailMessagesClient, contactDraftEmailMessagesClient } from '@/api/clients';
import EmailMessageListItem from './EmailMessageListItem.vue';
import DraftEmailMessageListItem from './DraftEmailMessageListItem.vue';

export default {
  components: {
    EmailMessageListItem,
    DraftEmailMessageListItem,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      emailMessages: [],
      draftEmailMessages: [],
    };
  },
  methods: {
    fetchData() {
      return Promise.all([
        contactEmailMessagesClient
          .list(this.contact.id, {
            include: 'third_party_service',
          })
          .then((response) => {
            this.emailMessages = response.data;
          }),
        contactDraftEmailMessagesClient
          .list(this.contact.id, {
            include: 'third_party_service',
          })
          .then((response) => {
            this.draftEmailMessages = response.data;
          }),
      ]);
    },
    handleViewEmailMessage(emailMessage) {
      this.$modal.show({
        component: () =>
          import(
            '@/components/ContactEmailMessage/ViewEmailMessageDialog/ViewEmailMessageDialog.vue'
          ),
        props: {
          contact: this.contact,
          emailMessageId: emailMessage.id,
        },
        hideEvent: 'close',
      });
    },
    handleEditEmailMessage(emailMessage) {
      this.$modal.show({
        component: () =>
          import(
            '@/components/ContactEmailMessage/WriteEmailMessageDialog/WriteEmailMessageDialog.vue'
          ),
        props: {
          contact: this.contact,
          contactRequest: this.contactRequest,
          emailMessageId: emailMessage.id,
        },
        on: {
          saved: () => {
            this.fetchData();
          },
          sent: () => {
            this.fetchData();
          },
        },
        hideEvent: 'close',
      });
    },
    handleDeleteEmailMessage(emailMessage) {
      this.$modal.show({
        component: () =>
          import(
            '@/components/ContactEmailMessage/DeleteEmailMessageDialog/DeleteEmailMessageDialog.vue'
          ),
        props: {
          action: async (emailMessageId) => {
            try {
              await contactDraftEmailMessagesClient.destroy(this.contact.id, emailMessageId);

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          emailMessage,
        },
        on: {
          deleted: () => {
            this.fetchData();
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
